(function ($) {
    const selecionarRamal = function (ramais) {
        return new Promise(function (resolve, reject) {
            if (!ramais.length) {
                const erro = new Error(
                    "Nenhum ramal foi encontrado para o seu usuário na Bem Melhor."
                );
                erro.code = "bemmelhor_v2_sem_ramal";
                reject(erro);
                return;
            }

            if (ramais.length === 1) {
                resolve(ramais[0].extensionNumber);
                return;
            }

            const $modal = $("#modalSelecionarRamalBemMelhorV2");
            const $select = $("#js-bemmelhor-v2-ramal-select");
            let confirmado = false;

            if (!$modal.length) {
                reject(new Error("Modal de seleção de ramal não encontrado."));
                return;
            }

            $select.empty();

            ramais.forEach(function (ramal) {
                const label = ramal.elocaUserName
                    ? `${ramal.extensionNumber} - ${ramal.elocaUserName}`
                    : ramal.extensionNumber;

                $select.append(
                    `<option value="${ramal.extensionNumber}">${label}</option>`
                );
            });

            $modal.off("click", ".js-bemmelhor-v2-confirmar-ramal");
            $modal.on("click", ".js-bemmelhor-v2-confirmar-ramal", function () {
                confirmado = true;
                const exten = $select.val();
                $modal.modal("hide");
                resolve(exten);
            });

            $modal.off("hidden.bs.modal.bemmelhorV2");
            $modal.on("hidden.bs.modal.bemmelhorV2", function (event) {
                if (!event.target.classList.contains("modal")) {
                    return;
                }

                if (!confirmado) {
                    reject(new Error("Seleção de ramal cancelada."));
                }
            });

            $modal.modal("show");
        });
    };

    const normalizarRamais = function (lista) {
        if (!Array.isArray(lista)) {
            return [];
        }

        return lista
            .map(function (ramal) {
                const extensionNumber =
                    ramal.extensionNumber || ramal.extension || ramal.ramal || null;

                if (!extensionNumber) {
                    return null;
                }

                return {
                    elocaUserId: ramal.elocaUserId || null,
                    elocaUserName: ramal.elocaUserName || null,
                    extensionNumber: String(extensionNumber),
                };
            })
            .filter(Boolean);
    };

    const axiosVoipConfig = {
        headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
            "ngrok-skip-browser-warning": "true",
        },
        maxRedirects: 0,
        validateStatus: function (status) {
            return status >= 200 && status < 300;
        },
    };

    const buscarRamais = function (url) {
        return window.axios.get(url, axiosVoipConfig).then(function (response) {
            const dados = response.data;

            // HTML de login/ngrok/erro chega como string; JSON válido chega como objeto.
            if (typeof dados === "string") {
                throw new Error(
                    "A consulta de ramais retornou HTML em vez de JSON. Confirme se está logado em " +
                        window.location.origin +
                        "/painel"
                );
            }

            if (!dados || typeof dados !== "object" || Array.isArray(dados)) {
                throw new Error(
                    "Resposta inesperada ao buscar ramais. Recarregue a página e tente novamente."
                );
            }

            if (dados.error) {
                const erro = new Error(
                    dados.message || "Não foi possível buscar os ramais."
                );
                erro.code = dados.code || null;
                erro.user = dados.user || null;
                throw erro;
            }

            return normalizarRamais(dados.userMappings || []);
        }).catch(function (error) {
            if (error && error.response) {
                const status = error.response.status;
                const dados = error.response.data || {};

                if (status === 401 || status === 302) {
                    throw new Error(
                        dados.message ||
                            "Sessão expirada ou não autenticada. Faça login novamente em " +
                                window.location.origin +
                                "/painel"
                    );
                }

                if (typeof dados === "object" && dados.message) {
                    const erro = new Error(dados.message);
                    erro.code = dados.code || null;
                    erro.user = dados.user || null;
                    throw erro;
                }
            }

            throw error;
        });
    };

    const iniciarLigacao = function (callUrl, exten) {
        const separador = callUrl.indexOf("?") >= 0 ? "&" : "?";

        return window.axios.get(
            `${callUrl}${separador}exten=${encodeURIComponent(exten)}`,
            axiosVoipConfig
        );
    };

    const limparDetalhesModal = function ($modal) {
        $modal.find(".js-bemmelhor-v2-mensagem-detalhes").addClass("d-none");
        $modal.find(".js-bemmelhor-v2-mensagem-subtitulo").text("");
        $modal.find(".js-bemmelhor-v2-mensagem-lista").empty();
    };

    const preencherDetalhesSemRamal = function ($modal, user) {
        const $detalhes = $modal.find(".js-bemmelhor-v2-mensagem-detalhes");
        const $lista = $modal.find(".js-bemmelhor-v2-mensagem-lista");
        const usuarioLabel = user && user.id
            ? `${user.name || "Usuário"} (ID ${user.id})`
            : "seu usuário logado";

        $modal
            .find(".js-bemmelhor-v2-mensagem-subtitulo")
            .text(
                `A Bem Melhor não retornou ramal para ${usuarioLabel}. Para liberar o click-to-call:`
            );

        $lista.empty();
        [
            "Acesse o painel da Bem Melhor → user-mappings.",
            `Vincule o usuário do Eloca ${usuarioLabel} a pelo menos um ramal.`,
            "Salve o vínculo e tente ligar novamente nesta tela.",
        ].forEach(function (item) {
            $lista.append(`<li class="mb-1">${item}</li>`);
        });

        $detalhes.removeClass("d-none");
    };

    const exibirMensagem = function (tipo, mensagem, opcoes) {
        const options = opcoes || {};
        const $modal = $("#modalMensagemBemMelhorV2");
        const $alert = $modal.find(".js-bemmelhor-v2-mensagem-alert");
        const $texto = $modal.find(".js-bemmelhor-v2-mensagem-texto");
        const $titulo = $("#modalMensagemBemMelhorV2Label");

        if (!$modal.length) {
            if (tipo === "success" && typeof window.showToastSuccess === "function") {
                window.showToastSuccess(document, mensagem);
                return;
            }

            if (tipo === "danger" && typeof window.showToastDanger === "function") {
                window.showToastDanger(document, mensagem);
                return;
            }

            if (tipo === "warning" && typeof window.showToastWarning === "function") {
                window.showToastWarning(document, mensagem);
            }

            return;
        }

        const classesAlert = {
            success: "alert-success",
            danger: "alert-danger",
            warning: "alert-warning",
        };

        const titulos = {
            success: "Chamada iniciada",
            danger: "Não foi possível completar",
            warning: "Atenção",
        };

        limparDetalhesModal($modal);

        $alert
            .removeClass("alert-success alert-danger alert-warning")
            .addClass(classesAlert[tipo] || "alert-danger");
        $titulo.text(options.titulo || titulos[tipo] || "Ligação");
        $texto.text(mensagem);

        if (options.code === "bemmelhor_v2_sem_ramal") {
            $titulo.text("Ramal não encontrado");
            preencherDetalhesSemRamal($modal, options.user);
        }

        $modal.modal("show");
    };

    Eloca.behaviors.bemmelhorV2Ligar = function (context) {
        $(".js-bemmelhor-v2-ligar", context).on("click", function (event) {
            event.preventDefault();

            const $botao = $(this);
            const ramaisUrl =
                $botao.attr("data-ramais-url") || $botao.data("ramais-url");
            const callUrl =
                $botao.attr("data-call-url") || $botao.data("call-url");
            const userFromButton = {
                id: $botao.attr("data-user-id") || null,
                name: $botao.attr("data-user-name") || null,
            };

            if (!ramaisUrl || !callUrl) {
                exibirMensagem("danger", "Configuração de ligação incompleta.");
                return;
            }

            $botao.prop("disabled", true);

            buscarRamais(ramaisUrl)
                .then(function (ramais) {
                    return selecionarRamal(ramais);
                })
                .then(function (exten) {
                    return iniciarLigacao(callUrl, exten);
                })
                .then(function (response) {
                    const dados = response.data || {};

                    if (dados.error) {
                        throw new Error(
                            dados.message || "Não foi possível iniciar a chamada."
                        );
                    }

                    exibirMensagem(
                        "success",
                        dados.message || "Chamada iniciada com sucesso."
                    );
                })
                .catch(function (error) {
                    if (error && error.message === "Seleção de ramal cancelada.") {
                        return;
                    }

                    const dadosResposta =
                        error && error.response && error.response.data
                            ? error.response.data
                            : {};

                    const mensagem =
                        dadosResposta.message ||
                        (error && error.message) ||
                        "Não foi possível iniciar a chamada.";

                    exibirMensagem("danger", mensagem, {
                        code:
                            dadosResposta.code ||
                            (error && error.code) ||
                            null,
                        user:
                            dadosResposta.user ||
                            (error && error.user) ||
                            userFromButton,
                    });
                })
                .finally(function () {
                    $botao.prop("disabled", false);
                });
        });
    };
})(jQuery);
